import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

export type ToastSeverity = 'info' | 'error' | 'success';
export type ToastDetails = { header: string; message?: string };

@Injectable({ providedIn: 'root' })
export class ToastService {
  private _message$ = new Subject<[ToastDetails, ToastSeverity]>();

  public message$ = this._message$.asObservable();

  public add(details: ToastDetails, severity: ToastSeverity = 'info', error?: any) {
    this._message$.next([
      { header: details.header, message: error ? this.formatMessageWithError(details.message as string, error) : details.message },
      severity
    ]);
  }

  private formatMessageWithError(message: string, error: any) {
    const errorText = error.error?.error?.message || error.message || error.toString();
    return message ? `${message}: ${errorText}` : errorText;
  }
}
